"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuComponent = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var mithril_component_1 = require("../mithril.component");
var theme_1 = require("../theme");
var menu_item_1 = require("./menu.item");
var menu_style_1 = require("./menu.style");
(0, theme_1.addStyles)(menu_style_1.Style);
var MenuComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MenuComponent, _super);
    function MenuComponent(attrs) {
        var _this = _super.call(this) || this;
        _this.closeTask = new core_shared_1.IkeDelayedTask(_this.remove, 200);
        _this.isOpen = false;
        _this.isClosing = false;
        _this.selectedItemIndex = 0;
        _this.className = attrs.className;
        _this.itemsFunc = attrs.items;
        _this.openFunc = attrs.open;
        _this.eventContext = services_1.Services.Input.getContext();
        return _this;
    }
    MenuComponent.prototype.onCreate = function () {
        var _this = this;
        if (typeof this.openFunc === 'function') {
            this.reaction(function () { return _this.openFunc(); }, this.toggle, { fireImmediately: true });
        }
    };
    Object.defineProperty(MenuComponent.prototype, "nodes", {
        get: function () {
            var _this = this;
            if (!this.isOpen) {
                return null;
            }
            var className = "".concat(menu_style_1.CSS.menu, " ").concat(this.isOpen ? menu_style_1.CSS.isOpen : menu_style_1.CSS.isClosed);
            if (this.className != null) {
                className += " ".concat(this.className);
            }
            if (this.isClosing) {
                className += " ".concat(menu_style_1.CSS.isClosing);
            }
            var items = this.items;
            if (items == null || items.length === 0) {
                return null;
            }
            var children = [];
            for (var i = 0; i < items.length; i++) {
                var menuItem = items[i];
                if (menuItem.component) {
                    children.push(menuItem.view);
                }
                else {
                    var selected = i === this.selectedItemIndex;
                    children.push(menu_item_1.MenuItemWrapperComponent.view(this, menuItem, selected));
                }
                if (menuItem.divider) {
                    children.push((0, mithril_1.m)('div', { className: menu_style_1.CSS.divider }));
                }
            }
            return (0, mithril_1.m)('div', {
                className: className,
                oncreate: function (node) { return services_1.Services.FocusAway.from(node.dom, _this.hide); }
            }, children);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuComponent.prototype, "items", {
        get: function () {
            var menuItems = this.itemsFunc();
            if (menuItems == null) {
                return [];
            }
            return menuItems;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuComponent.prototype, "hasUsableItems", {
        get: function () {
            var items = this.items;
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var item = items_1[_i];
                if (item.visible !== false && !item.disabled) {
                    return true;
                }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    MenuComponent.prototype.remove = function () {
        this.isOpen = false;
        this.isClosing = false;
    };
    MenuComponent.prototype.hide = function () {
        this.toggle(false);
    };
    MenuComponent.prototype.show = function () {
        this.toggle(true);
    };
    MenuComponent.prototype.toggle = function (shouldOpen) {
        if (shouldOpen) {
            this.isOpen = true;
            this.isClosing = false;
            this.closeTask.cancel();
            this.bindKeyboardEvents();
            var selectedIndex = this.items.findIndex(function (i) { return i.selected; });
            this.selectedItemIndex = Math.max(0, selectedIndex);
        }
        else {
            this.isClosing = true;
            if (this.closeTask.isActive) {
                return;
            }
            this.closeTask.delay();
            this.eventContext.destroy();
        }
    };
    MenuComponent.prototype.selectItem = function (item) {
        var selectedIndex = this.items.findIndex(function (i) { return i === item; });
        this.selectedItemIndex = Math.max(0, selectedIndex);
    };
    MenuComponent.prototype.selectCurrentItem = function (e) {
        e.event.stopPropagation();
        e.event.preventDefault();
        var menuItem = this.getSelectedItem();
        if (menuItem != null && menuItem.action != null) {
            menuItem.action();
        }
        this.hide();
    };
    MenuComponent.prototype.getSelectedItem = function () {
        return this.items[this.selectedItemIndex];
    };
    MenuComponent.prototype.selectItemIndex = function (delta) {
        var items = this.items;
        var index = this.wrap(this.selectedItemIndex + delta, items.length);
        while (items[index].visible === false || items[index].disabled) {
            if (index === this.selectedItemIndex) {
                // No other selectable items. Stop
                return;
            }
            index = this.wrap(index + delta, items.length);
        }
        this.selectedItemIndex = index;
    };
    MenuComponent.prototype.wrap = function (index, count) {
        return ((index % count) + count) % count;
    };
    MenuComponent.prototype.bindKeyboardEvents = function () {
        var _this = this;
        this.eventContext.on(this.eventContext.Code.ArrowUp, function () { return _this.selectItemIndex(-1); });
        this.eventContext.on(this.eventContext.Code.ArrowDown, function () { return _this.selectItemIndex(1); });
        this.eventContext.on(this.eventContext.Code.Enter, this.selectCurrentItem);
        this.eventContext.on(this.eventContext.Code.Escape, this.hide);
    };
    MenuComponent.prototype.onRemove = function () {
        _super.prototype.onRemove.call(this);
        this.eventContext.destroy();
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], MenuComponent.prototype, "isOpen", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], MenuComponent.prototype, "isClosing", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], MenuComponent.prototype, "selectedItemIndex", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], MenuComponent.prototype, "items", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], MenuComponent.prototype, "hasUsableItems", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], MenuComponent.prototype, "remove", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], MenuComponent.prototype, "hide", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], MenuComponent.prototype, "show", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], MenuComponent.prototype, "toggle", null);
    tslib_1.__decorate([
        mobx_1.action
    ], MenuComponent.prototype, "selectItem", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], MenuComponent.prototype, "selectCurrentItem", null);
    tslib_1.__decorate([
        mobx_1.action
    ], MenuComponent.prototype, "selectItemIndex", null);
    return MenuComponent;
}(mithril_component_1.IMithrilStateComponent));
exports.MenuComponent = MenuComponent;
//# sourceMappingURL=menu.js.map